import UIfx from "uifx";
import bell from "./Audio/Winner.mp3";

export const Bell = new UIfx(bell, {
  volume: 0.4
});
